import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Confetti from "react-confetti";
import "./static_home.css";
import { Container, Card } from "react-bootstrap";

const ThankYou = () => {
    const { i18n, t} = useTranslation("global");
    const { lang } = useParams();
    const direction = lang === "en" ? "ltr" : "rtl";
  
    useEffect(() => {
      if (lang && i18n.language !== lang) {
        i18n.changeLanguage(lang);
      }
    }, [lang, i18n]);

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  }); 

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section
      className="py-5 d-flex align-items-center justify-content-center"
      style={{ minHeight: "60vh", background: "#ebfeff" }}
      dir={direction}
    >
      <Confetti width={windowSize.width} height={windowSize.height} numberOfPieces={250} recycle={false} />
      <Container>
        <Card
          className="shadow-lg border-0 mx-auto p-4 text-center"
          style={{ maxWidth: 500, background: "#fff", borderRadius: 24 }}
          data-aos="fade-up"
        >
          <Card.Body>
            <div className="mb-4">
              <svg width="64" height="64" fill="none" viewBox="0 0 64 64">
                <circle cx="32" cy="32" r="32" fill="#59C6C9" fillOpacity="0.1" />
                <path d="M20 33.5L29 42L44 27" stroke="#59C6C9" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h1 className="ecombo-primary fw-bold mb-3" style={{ fontSize: 32 }}>
              {t("static_home.thankyou.title")}
            </h1>
            <p className="lead mb-2" style={{ fontSize: 18 }}>
              {t("static_home.thankyou.received")}
            </p>
            <p className="text-muted mb-0" style={{ fontSize: 16 }}>
              {t("static_home.thankyou.response")}
            </p>
          </Card.Body>
        </Card>
      </Container>
    </section>
  );
};

export default ThankYou;